module.exports = __webpack_public_path__ + "img/calculator.1b2fda10.png";